import { mixins, theme } from '@approvalmax/theme';
import styled from 'styled-components';

export const TableErrorHint = styled.div`
    margin-top: 8px;
    color: ${theme.color.red100};
    ${mixins.font('body', 'xsmall', 'regular')};
`;
